(function () {
  function enabled() {
    return document.body.classList.contains('template-index') || document.body.classList.contains('template-collection');
  }

  function refreshCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cp-tools a[href="/cart"],.cp-compact-header__tools a[href="/cart"],.site-header__cart,[data-cart-count]').forEach(function (link) {
          var count = link.querySelector('span');
          if (!count && cart.item_count > 0) {
            count = document.createElement('span');
            link.appendChild(count);
          }
          if (count) count.textContent = cart.item_count;
          link.setAttribute('aria-label', 'კალათა: ' + cart.item_count);
        });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      })
      .catch(function () {});
  }

  function markSoldOut(button) {
    button.textContent = 'არ არის მარაგში';
    button.disabled = true;
    button.classList.add('is-sold-out');
    button.setAttribute('aria-disabled', 'true');
  }

  function addButton(card, container) {
    if (!container || container.querySelector('.cp-card__add-to-cart')) return;

    var title = (card.querySelector('strong') && card.querySelector('strong').textContent.trim()) ||
      (card.querySelector('img') && card.querySelector('img').alt) || '';
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'cp-card__add-to-cart';
    button.textContent = 'კალათაში დამატება';
    button.setAttribute('aria-label', 'კალათაში დამატება: ' + title);

    if (card.getAttribute('data-available') === 'false') markSoldOut(button);

    button.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (button.disabled) return;

      button.disabled = true;
      var initial = button.textContent;
      fetch(card.href + '.js')
        .then(function (response) {
          if (!response.ok) throw new Error();
          return response.json();
        })
        .then(function (product) {
          var variant = product.variants.find(function (item) { return item.available; });
          if (!variant) {
            markSoldOut(button);
            throw new Error('sold-out');
          }
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: variant.id, quantity: 1 })
          });
        })
        .then(function (response) {
          if (!response.ok) throw new Error();
          refreshCartCount();
          document.dispatchEvent(new CustomEvent('cp:cart-added', { detail: { trigger: button } }));
          button.textContent = 'დამატებულია';
          button.classList.add('is-added');
          window.setTimeout(function () {
            button.textContent = initial;
            button.classList.remove('is-added');
            button.disabled = false;
          }, 1300);
        })
        .catch(function (error) {
          if (error && error.message === 'sold-out') return;
          button.textContent = 'ვერ დაემატა';
          window.setTimeout(function () {
            button.textContent = initial;
            button.disabled = false;
          }, 1300);
        });
    });

    container.appendChild(button);
  }

  function setup() {
    if (!enabled()) return;
    document.querySelectorAll('.cp-card').forEach(function (card) {
      addButton(card, card.querySelector('.cp-card__image'));
    });
    if (document.body.classList.contains('template-index')) {
      document.querySelectorAll('.cp-featured__book').forEach(function (card) { addButton(card, card); });
    }
  }

  document.addEventListener('DOMContentLoaded', setup);
  document.addEventListener('cp:kids-shelf-ready', setup);
  [0, 400, 1200].forEach(function (delay) { window.setTimeout(setup, delay); });
})();
